module.exports = __webpack_public_path__ + "static/gradients_purple-e88e9273b8fcc85d190ad2760e081c6a.jpg";